import template from "./project-qr-profile.pug"
import reactTemplate from "./react-project-qr-profile.pug"
import { DateUtils } from "@/lib/utils/date"
import { PageContentViewModel } from "@/lib/vm/page-content-viewmodel"
import renderReactComponent from "@/react/render-react-component"

### Auth, Real-Time & Stores ###
import { defaultStoreCore as defaultStore } from "@/stores/default-store.core"
import { ProjectStore } from "@/stores/project-store.core"

export class ProjectQrProfileViewModel extends PageContentViewModel
   reactEnabled = true
   constructor: (companyQrId, projectQrId) ->
      super(
         if reactEnabled then reactTemplate() else template(),
         "Project QR Profile",
      )
      this.reactEnabled = reactEnabled
      @companyQrId = companyQrId
      @projectQrId = projectQrId

   addedToParent: () =>
      if this.reactEnabled
         this.reactRoot = renderReactComponent(
            "react-project-qr-profile",
            "ProjectQrProfile",
            {
               companyQrId: @companyQrId,
               projectQrId: @projectQrId,
            }
         )

   formatMsDate: (ms) ->
      return DateUtils.getShortNumericDate(new Date(ms), defaultStore.getDateFormat())

   formatTimeVal: (time) ->
      return DateUtils.formatTimeVal(time)

   formattedDay: (day) ->
      return DateUtils.formatDetachedDay(day, defaultStore.getDateFormat())

   formatPhone: (phone) ->
      return "#{phone.slice(0,2)}-#{phone.slice(2,5)}-#{phone.slice(5,8)}-#{phone.slice(8,12)}"

   getPhotoUrl: (baseUrl) ->
      fragments = baseUrl.split("upload/")
      url = "#{fragments[0]}upload/g_face,c_thumb,w_60,h_60/#{fragments[1]}"
      return url

   getArrayString: (vals) ->
      str = ''
      for val in vals
         str += "#{val}, "
      return str.slice(0, -2)

   loadData: ->
      try
         result = await ProjectStore.getProjectQrInfo(@projectQrId, @companyQrId).payload
         @qrInfo(result.data)
      catch Error
         console.log("Error", Error)
         err = if typeof Error.message == Object then JSON.parse(Error.message) else Error
         if err.detailCode == 'qrCompanyNotFound' or err.detailCode == 'projectQrDisabled'
            @errorMessage("QR profiles for Projects have been disabled by the admins of this account.")
         else if err.detailCode == 'qrModuleDisabled'
            @errorMessage("The QR Code module has been disabled for this account.")
         else if err.detailCode == 'qrEntityArchived'
            @errorMessage("The Project for this QR code has been removed.")
         else
            @errorMessage("Invalid Scan. The image may be corrupted")
